import React from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

import { Checkbox, InputNumber } from 'mailup-web-components'

import { modalBeeContentDialogState } from '../recoil/state'

import styled from '@emotion/styled'

const ContentsRepeatContainer = styled.div`
  display: flex;
  align-items: center;
`

const InputRepeat = styled(Checkbox)`
  margin-right: 10px;

  & label {
    font-size: 15px;
    font-weight: 500;
  }
`

const InputRepeatCount = styled(InputNumber)`
  width: 70px;
  margin-right: 10px;
  font-size: 15px;
  font-weight: 500;
`

const LabelRepeatCount = styled.span`
  font-size: 15px;
  font-weight: 500;
`

const LayoutInputContentsRepeat = () => {
  const intl = useIntl()
  const { repeat, repeatTimes } = useRecoilValue(modalBeeContentDialogState)
  const setState = useSetRecoilState(modalBeeContentDialogState)
  const handleChangeRepeat = () =>
    setState(prev => ({ ...prev, repeat: !prev.repeat }))

  const handleChangeRepeatTimes = v =>
    setState(prev => ({ ...prev, repeatTimes: v }))

  return (
    <ContentsRepeatContainer>
      <InputRepeat
        value
        checked={repeat}
        label={intl.formatMessage({
          id: 'Load.BeeContentDialog.RepeatSelectedLayout'
        })}
        onChange={handleChangeRepeat}
        labelClassName='c-checkbox__label'
      />
      <InputRepeatCount
        min={1}
        max={30}
        value={repeatTimes}
        disabled={!repeat}
        onChange={handleChangeRepeatTimes}
      />
      <LabelRepeatCount>
        {intl.formatMessage({ id: 'Load.BeeContentDialog.RepeatTimes' })}
      </LabelRepeatCount>
    </ContentsRepeatContainer>
  )
}

export default LayoutInputContentsRepeat
